import React, { useContext, useEffect } from "react";
import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import Text from "~/components-shared/Text";
import DefaultSideBar from "~/components/DefaultSideBar";
import CoreContext from "~/lib/context";
const Section = styled.section`
  padding: 4em;

  @media (max-width: 768px) {
    padding: 1em;
  }
`;
const RestrictedSection = () => {
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const {
    setSidebar
  } = useContext(CoreContext);
  useEffect(() => {
    setSidebar(/*#__PURE__*/React.createElement(DefaultSideBar, null));
  }, [setSidebar]);
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    color: colors.text.disabled,
    align: "center"
  }, t("RestrictedSection.title")));
};
export default RestrictedSection;